function ContextPickerModalController($scope, $uibModalInstance, brands, callCenters, stores, showBrandContext, showCallCenterContext, showStoreContext, PermissionService, $timeout) {

    var self = this;

    self.initialise = function() {
        $scope.brands = brands;
        $scope.callcenters = callCenters;
        $scope.stores = stores;
        $scope.showBrandContext = showBrandContext;
        $scope.showCallCenterContext = showCallCenterContext;
        $scope.showStoreContext = showStoreContext;
        var user = PermissionService.user;

        // Set default values
        $scope.showBrandDropdown = false;
        $scope.showCallCenterDropdown = false;
        $scope.showStoreDropdown = false;
        $scope.showContext = true;

        $scope.context = new Dashboard.Models.Permissions.RoleContext();

        var userContextSelected = false;
        if($scope.showBrandContext) {
            $scope.context.ContextType = Dashboard.ContextTypes.BrandContext;
        }
        else if ($scope.showCallCenterContext) {
            $scope.context.ContextType = Dashboard.ContextTypes.CallCenterContext;
        }
        else if ($scope.showStoreContext) {
            $scope.context.ContextType = Dashboard.ContextTypes.StoreContext;
        }

        if (user.hasSingleContext) {
            $scope.showContext = false;
        }

        if (userContextSelected) {
            $scope.contextChanged(false);
        }
        else {
            $scope.contextChanged(true);
        }
    };

    $scope.contextChanged = function (resetValues) {
        // Reset the values if a new context is selected. If a current one is loaded when the modal is first shown,
        // then don't reset the values
        if (resetValues) {
            $scope.showBrandDropdown = false;
            $scope.showCallCenterDropdown = false;
            $scope.showStoreDropdown = false;

            $scope.context.BrandId = undefined;
            $scope.context.BrandName = undefined;
            $scope.context.CallCenterId = undefined;
            $scope.context.CallCenterName = undefined;
            $scope.context.StoreId = undefined;
            $scope.context.StoreName = undefined;
        }

        var autoPickContext = false;
        var user = PermissionService.user;
        if ($scope.context.ContextType === Dashboard.ContextTypes.BrandContext){
            $scope.showBrandDropdown = true;
            $scope.selectedContext = 'Brand';
            // If at least one brand is available then select the first one by default
            if ($scope.brands.length > 0 && !$scope.context.BrandId) {
                $scope.context.BrandId = $scope.brands[0].Id;
                $scope.context.BrandName = $scope.brands[0].Name;
            }
            autoPickContext = $scope.brands.length === 1 && user.hasSingleContext;
        }
        else if ($scope.context.ContextType === Dashboard.ContextTypes.CallCenterContext){
            $scope.showCallCenterDropdown = true;
            $scope.selectedContext = 'Callcenter';
            // If at least one callcenter is available then select the first one by default
            if ($scope.callcenters.length > 0 && !$scope.context.CallCenterId) {
                $scope.context.CallCenterId = $scope.callcenters[0].Id;
                $scope.context.CallCenterName = $scope.callcenters[0].Name;
            }
            autoPickContext = $scope.callcenters.length === 1 && user.hasSingleContext;
        }
        else if($scope.context.ContextType === Dashboard.ContextTypes.StoreContext) {
            $scope.showStoreDropdown = true;
            $scope.selectedContext = 'Store';
            // If at least one store is available then select the first one by default
            if ($scope.stores.length > 0 && !$scope.context.StoreId) {
                $scope.context.StoreId = $scope.stores[0].Id;
                $scope.context.StoreName = $scope.stores[0].Name;
            }
            autoPickContext = $scope.stores.length === 1 && user.hasSingleContext;
        }

        // if there is only one selectable option, set the context and don't show the modal
        if(autoPickContext){
            $timeout($scope.pickContext)
        }
    };

    $scope.brandChanged = function () {
        var selectedBrand = _.findWhere($scope.brands, { Id: $scope.context.BrandId });
        if (selectedBrand) {
            $scope.context.BrandName = selectedBrand.Name;
        }
    };

    $scope.callCenterChanged = function () {
        var selectedCallCenter = _.findWhere($scope.callcenters, { Id: $scope.context.CallCenterId });
        if (selectedCallCenter) {
            $scope.context.CallCenterName = selectedCallCenter.Name;
        }
    };

    $scope.storeChanged = function () {
        var selectedStore = _.findWhere($scope.stores, { Id: $scope.context.StoreId });
        if (selectedStore) {
            $scope.context.StoreName = selectedStore.Name;
        }
    };

    $scope.pickContext = function () {
        PermissionService.userContext = $scope.context;
        PermissionService.notifyContextChanged();
        $uibModalInstance.close();
    };

    self.initialise();
}

angular
    .module('dashboard')
    .controller('ContextPickerModalController', ['$scope', '$uibModalInstance', 'brands', 'callCenters', 'stores', 'showBrandContext', 'showCallCenterContext', 'showStoreContext', 'PermissionService', '$timeout', ContextPickerModalController]);
